import RestService from './RestService'

export default class ViewService extends RestService {
  constructor() {
    super('views')
  }

  getData(view, table, parentDocumentId, relatedField) {
    return new Promise((resolve, reject) => {
      let url = this.baseUrl + '/api/v1/' + this.modelPath + '/data/' + view.id + '.json?t=' + Date.now()

      if(parentDocumentId && relatedField) {
        url = url + '&parent_id=' + parentDocumentId + '&related_id=' + relatedField.index
      }

      this.http.get(url)
          .set('x-api-token', this.authToken)
          .end((error, response) => {
            if (response.status === 200) {
              const records = JSON.parse(response.text)
              for(let i = 0; i < records.length; i++) {
                records[i].editMode = false

                // ensure every field in a record is reactive
                // for very large tables this will have a performance penalty
                // one work around it to save the record with a field value
                // when the field is created.
                for(let j = 0; j < table.fields.length; j++) {
                  let field = table.fields[j]

                  if(records[i][field.index] === undefined) {
                    records[i][field.index] = webase.utils.table.initField(field)
                  }
                }
              }
              webase.model.documents = records
              resolve(records)
            } else {
              reject(response.statusText)
            }
          })
    })
  }
}